import { render, staticRenderFns } from "./extinctionDetails.vue?vue&type=template&id=8314d320"
import script from "./extinctionDetails.vue?vue&type=script&lang=js"
export * from "./extinctionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports